<div class="transport-type-editor" [formGroup]="detailsFormGroup">
  <div class="row">
    <mat-form-field class="flex-grow" appearance="fill">
      <mat-label>
        <sc-dictionary-label dictionaryKey="tmc-yard.common.type"></sc-dictionary-label>
      </mat-label>
      <mat-select formControlName="transportType" name="transportType">
        @for (t of transportTypes; track t) {
          <mat-option [value]="t">
            <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.transport-type.{{t}}"></sc-dictionary-label>
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
</div>
